function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2946_14)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.1446 42.8796V78.7832C16.1446 84.5663 20.7229 89.1446 26.506 89.1446H108.434C114.217 89.1446 118.795 84.5663 118.795 78.7832V33C118.795 27.2169 114.217 22.6386 108.434 22.6386H104.337C100.723 22.6386 97.8313 19.747 97.8313 16.1326C97.8313 10.3494 93.253 5.77112 87.4699 5.77112H47.4699C44.0964 5.77112 40.9639 7.45787 39.0362 10.1085",
  stroke: "#CCCCCC",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.4698 74.2048C78.6486 74.2048 87.7108 65.1426 87.7108 53.9639C87.7108 42.7851 78.6486 33.7229 67.4698 33.7229C56.2911 33.7229 47.2289 42.7851 47.2289 53.9639C47.2289 65.1426 56.2911 74.2048 67.4698 74.2048Z",
  stroke: "#CCCCCC",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.651 45.0482C105.845 45.0482 108.434 42.459 108.434 39.2651C108.434 36.0711 105.845 33.4819 102.651 33.4819C99.4567 33.4819 96.8675 36.0711 96.8675 39.2651C96.8675 42.459 99.4567 45.0482 102.651 45.0482Z",
  stroke: "#CCCCCC",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1687 43.8434C33.7467 43.8434 43.1325 34.4576 43.1325 22.8795C43.1325 11.3015 33.7467 1.91568 22.1687 1.91568C10.5907 1.91568 1.20483 11.3015 1.20483 22.8795C1.20483 34.4576 10.5907 43.8434 22.1687 43.8434Z",
  stroke: "#CCCCCC",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.7711 25.5302L18.3132 31.0723",
  stroke: "#CCCCCC",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.3253 18.0603L18.3132 31.0723",
  stroke: "#CCCCCC",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2946_14"
}, /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 89.3976,
  fill: "white",
  transform: "translate(0 0.710861)"
})));
function SvgIcnCameraAccessNeeded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCameraAccessNeeded);
export default __webpack_public_path__ + "static/media/icn-camera-access-needed.5c29384c2932c9247a9ab99ec03b15fd.svg";
export { ForwardRef as ReactComponent };